<template>
  <BaseShowEditDatePicker
    v-model="value"
    :label="label"
    :name="name"
    :required="required"
    :disabled="disabled"
    :errors="errors"
    :edition-mode="true"
    @change="$emit('change', $event)"
  />
</template>

<script>
import moment from 'moment'

import BaseShowEditDatePicker from './BaseShowEditDatePicker.vue'

/**
 * Uncontrolled date picker: starts from `defaultValue` (`DD/MM/YYYY` or a
 * Date) and emits `change` with `{ attribute, value }`, as the former package
 * did. The default is emitted on mount too, so that a form sends the date it
 * shows (the document forms default to today).
 */
export default {
  name: 'BaseSimpleDatePicker',
  components: { BaseShowEditDatePicker },
  props: {
    defaultValue: { type: [String, Date], required: false, default: null },
    label: { type: String, required: false, default: null },
    name: { type: String, required: true },
    required: { type: Boolean, required: false, default: false },
    disabled: { type: Boolean, required: false, default: false },
    errors: { type: [Object, Array], required: false, default: null }
  },
  emits: ['change'],
  data() {
    return { value: this.toDisplayed(this.defaultValue) }
  },
  mounted() {
    if (this.value) {
      this.$emit('change', { attribute: this.name, value: this.value })
    }
  },
  methods: {
    toDisplayed(value) {
      if (!value) return null
      const date =
        value instanceof Date
          ? moment(value)
          : moment(value, 'DD/MM/YYYY', true)
      return date.isValid() ? date.format('DD/MM/YYYY') : null
    }
  }
}
</script>
